//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('inventoryArticleSearch', {
//        templateUrl: 'views/components/views/inventoryArticleSearch/inventoryArticleSearch.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['utilityService', 'inventoryArticleSearchService', function (utilityService, inventoryArticleSearchService) {
//            const vm = this;
    		
//            vm.model = {
//                searchTextButtons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('searchtext') },
//                    { id: 'search', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => loadInventoryArticles() }
//                ],
//                setting: {},
//                itemsListArticles: []
//            };

//            async function loadSetting() {
//                vm.model.setting = (await inventoryArticleSearchService.getSetting())[0];
//            }

//            async function loadInventoryArticles() {
//                if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.only_on_stock, true) !== true) return;

//                return vm.model.itemsListArticles = await inventoryArticleSearchService.listInventoryArticles(vm.model.setting);
//            }
            
//            function clear(id) {
//                switch (id) {
//                    case 'searchtext':
//                        vm.model.setting.searchtext = '';
//                        vm.model.itemsListArticles = [];
//                        break;
//                    default:
//                        break;
//                }
//            }
            
//            vm.searchArticles = function () {
//                loadInventoryArticles();
//            }
            
//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'only_on_stock':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.only_on_stock) !== true) return;

//                        vm.model.setting.only_on_stock = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.only_on_stock, true) !== true) return;

//                        loadInventoryArticles();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };
            
//            vm.$onInit = async function () {
//                await loadSetting();
//                loadInventoryArticles();
//            }
//        }]
//    });
//})();
